module.exports = __webpack_public_path__ + "img/map_10.b6a3484e.png";